module.exports = __webpack_public_path__ + "home-partner-image-strategy.pb1uT72G.svg";